import { FaTrashAlt } from 'react-icons/fa';
import { MdTaskAlt } from 'react-icons/md';
import { IoMdAdd } from 'react-icons/io';
import { CSS } from '@dnd-kit/utilities';
import { FaEdit } from 'react-icons/fa';
import { SortableContext, useSortable } from '@dnd-kit/sortable';
import { CiSaveUp2 } from 'react-icons/ci';
import { useState } from 'react';

import TaskCard from './TaskCard';

const KanbanBoardColumn = ({ column, onUpdateTitle, onDeleteColumn }) => {
  const { title, issues } = column;
  const [editTitle, setEditTitle] = useState(title);
  const [showeditInput, setShoweditInput] = useState(false);

  const { setNodeRef, transform, transition, isDragging } = useSortable({
    id: column.id,
    data: {
      type: 'column',
      column,
    },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const handleEditTitle = () => {
    setShoweditInput(true);
  };

  const handleChangeTitle = () => {
    setShoweditInput(false);
    onUpdateTitle(editTitle);
  };

  if (isDragging) {
    return (
      <div
        className="flex min-h-[400px] w-[380px] min-w-[380px] flex-col rounded-md border border-gray-700 bg-[#1c1c20] p-4"
        style={style}
        ref={setNodeRef}
      ></div>
    );
  }

  return (
    <div
      className="flex max-h-[800px] min-h-[400px] w-[380px] min-w-[380px] flex-col overflow-y-auto overflow-x-hidden rounded-md border border-gray-600 bg-[#1c1c20] p-2"
      style={style}
      ref={setNodeRef}
    >
      {/* for title */}
      {showeditInput ? (
        <div className="flex items-center justify-between rounded-md bg-black p-2">
          <input
            type="text"
            className="w-[80%] rounded-md bg-black p-2 text-white outline-none"
            value={editTitle}
            onChange={(e) => setEditTitle(e.target.value)}
          />
          <button onClick={handleChangeTitle}>
            <CiSaveUp2 className="font-bold text-white" size={20} />
          </button>
        </div>
      ) : (
        <div className="flex items-center justify-between rounded-md bg-zinc-800 p-4">
          <div className="flex items-center gap-4">
            <span>
              <MdTaskAlt className="font-bold text-white" size={15} />
            </span>
            <h3 className="text-base font-bold text-white">{title}</h3>
            <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-gray-600 text-white">
              {issues?.length}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <button className="rounded-md bg-gray-600 p-1.5">
              <IoMdAdd className="text-white" size={15} />
            </button>
            <button
              onClick={handleEditTitle}
              className="rounded-md bg-gray-600 p-1.5"
            >
              <FaEdit className="text-white" size={15} />
            </button>
            <button
              onClick={onDeleteColumn}
              className="rounded-md bg-gray-600 p-1.5"
            >
              <FaTrashAlt className="text-white" size={15} />
            </button>
          </div>
        </div>
      )}

      {/* for content */}
      <div className="my-2 flex flex-grow flex-col gap-1 overflow-y-auto overflow-x-hidden">
        <SortableContext items={column.issues.map((i) => i.id)}>
          {issues.map((issue) => (
            <TaskCard key={issue.id} issue={issue} columnId={column.id} />
          ))}
        </SortableContext>
      </div>

      {/* for footer */}
      <div>
        <button className="flex w-full items-center justify-center gap-2 rounded-md bg-zinc-800 py-2 text-base font-semibold text-white">
          <span>
            <IoMdAdd size={12} />
          </span>
          Create issue
        </button>
      </div>
    </div>
  );
};

export default KanbanBoardColumn;
